module.exports = __webpack_public_path__ + "img/G8.e40de2f7.png";